import { ds } from "../../core/models/dataService";
import { $, _, Backbone } from "js/vendor";
import { app } from "js/namespaces";
import { controls } from "../ui";
import { saveAs } from "file-saver";
import { ShowDialogAsync } from "../../react/components/Dialogs/BaseDialog";
import InputDialog from "../../react/components/Dialogs/InputDialog";
import { delay } from "js/core/utilities/promiseHelper";

export const TestRecorderUI = Backbone.View.extend({

    className: "test-recorder-ui",

    initialize: function() {
        window.innerHeight = 720;
        window.innerWidth = 1280;
        app.mainView.editorView.resize();

        $(window).on("keydown", event => {
            if (event.metaKey) {
                switch (event.which) {
                    case 188: //cmd-,
                        event.stopPropagation();
                        event.preventDefault();
                        if (app.testRecorder && app.testRecorder.isPlaying) {
                            this.stopRecording();
                        }
                        this.startRecording();
                        break;
                    case 190: // cmd-.
                        event.stopPropagation();
                        event.preventDefault();
                        this.stopRecording();
                        break;

                    case 191: // cmd-/
                        event.stopPropagation();
                        event.preventDefault();

                        if (app.testRecorder && app.testRecorder.isRecording) {
                            this.stopRecording();
                        }
                        this.saveRecording();
                        break;
                    case 13:
                        event.stopPropagation();
                        event.preventDefault();
                        if (app.testRecorder && app.testRecorder.isPlaying) {
                            this.stopPlayback();
                        } else {
                            this.playRecording();
                        }
                        break;
                }
            }
        });
    },

    render: function() {
        this.$el.empty();

        if (!app.testRecorder || (app.testRecorder.isRecording == false)) {
            this.$el.append(controls.createButton(this, {
                icon: "video_call",
                label: "Record Test",
                className: "test-runner-control",
                callback: () => {
                    this.startRecording();
                }
            }));

            // this.$el.append(controls.createButton(this, {
            //     icon: "settings_backup_restore",
            //     label: "Reset Canvas",
            //     className: "test-runner-control",
            //     callback: () => {
            //         app.currentCanvas.model = app.currentCanvas.slideTemplate.defaultData;
            //         app.currentCanvas.refreshCanvas();
            //     }
            // }));
        }

        if (app.testRecorder && app.testRecorder.isRecording) {
            this.$el.append(controls.createButton(this, {
                icon: "stop",
                label: "Stop Recording",
                className: "test-runner-control",
                callback: () => {
                    this.stopRecording();
                }
            }));
        }

        if (app.testRecorder && app.testRecorder.hasRecording) {
            let label = app.testRecorder.isPlaying ? "Stop Playback" : "Play Recording";
            this.$el.append(controls.createButton(this, {
                icon: "play_arrow",
                label: label,
                className: "test-runner-control",
                callback: () => {
                    if (app.testRecorder.isPlaying) {
                        this.stopPlayback();
                    } else {
                        this.playRecording();
                    }
                }
            }));

            this.$el.append(controls.createButton(this, {
                icon: "save",
                label: "Save Test",
                className: "test-runner-control",
                callback: () => {
                    this.saveRecording();
                }
            }));
        }

        return this;
    },

    startRecording: function() {
        app.testRecorder = new TestRecorder(this);
        app.testRecorder.startRecording();
        this.render();
    },

    stopRecording: function() {
        app.testRecorder.stopRecording();
        this.render();
    },

    playRecording: function() {
        app.testRecorder.play();
        this.render();
    },

    stopPlayback: function() {
        app.testRecorder.stopPlay();
        this.render();
    },

    saveRecording: function() {
        app.testRecorder.saveTest();
        this.render();
    }

});

export class TestRecorder {
    constructor(view) {
        this.view = view;
    }

    startRecording() {
        console.log("start recording");

        ds.selection.element = null;
        this.startModel = JSON.stringify(app.currentCanvas.model);
        this.snapshotIndex = 0;

        this.handleEventHandler = this.handleEvent.bind(this);
        this.debouncedHandleEventHandler = _.debounce(this.handleEventHandler, 20);

        document.body.addEventListener("mousedown", this.handleEventHandler, true);
        document.body.addEventListener("mouseup", this.handleEventHandler, true);
        document.body.addEventListener("click", this.handleEventHandler, true);
        document.body.addEventListener("keydown", this.handleEventHandler, true);
        document.body.addEventListener("keypress", this.handleEventHandler, true);
        document.body.addEventListener("keyup", this.handleEventHandler, true);
        document.body.addEventListener("mousemove", this.debouncedHandleEventHandler, true);

        this.eventLog = [];
        this.startTimer = new Date().getTime();

        this.isRecording = true;
        this.hasRecording = false;
    }

    serialializeEvent(event) {
        let ev = {
            type: event.type,
            bubbles: event.bubbles
        };
        switch (event.type) {
            case "mousedown":
            case "mouseup":
            case "click":
            case "mousemove":
                ev.clientX = event.clientX;
                ev.clientY = event.clientY;
                ev.offsetX = event.offsetX;
                ev.offsetY = event.offsetY;
                ev.button = event.button;
                break;
            case "keydown":
            case "keyup":
            case "keypress":
                ev.which = event.which;
                ev.keyCode = event.keyCode;
                ev.key = event.key;
                ev.shiftKey = event.shiftKey;
                ev.ctrlKey = event.ctrlKey;
                break;
        }

        return ev;
    }

    handleEvent(event) {
        if (!this.isRecording) return;

        if (event.type != "mousemove" && $(event.target).closest(".test-runner-control").length) {
            console.log("test-control event");
            return;
        }

        let now = new Date().getTime();
        let wait = now - this.startTimer;
        wait = Math.min(wait, 1500);

        let selector;
        if (event.target.id) {
            selector = "#" + event.target.id;
        } else {
            selector = $(event.target).getPath();
        }

        this.eventLog.push({
            type: "event",
            wait: wait,
            event: this.serialializeEvent(event),
            target: selector
        });

        if (event.type != "mousemove" || event.button == 1) {
            console.log("record event", event.type, $(event.target).getPath());
        }

        this.startTimer = now;
    }

    stopRecording() {
        console.log("stop recording");

        this.isRecording = false;
        this.hasRecording = true;

        document.body.removeEventListener("mousedown", this.handleEventHandler, true);
        // document.body.removeEventListener("mousemove", this.handleEventHandler, true);
        document.body.removeEventListener("mouseup", this.handleEventHandler, true);
        document.body.removeEventListener("click", this.handleEventHandler, true);

        document.body.removeEventListener("keydown", this.handleEventHandler, true);
        document.body.removeEventListener("keypress", this.handleEventHandler, true);
        document.body.removeEventListener("keyup", this.handleEventHandler, true);
    }

    play() {
        console.log("play recording");

        this.isPlaying = true;
        app.currentCanvas.model = JSON.parse(this.startModel);
        app.currentCanvas.refreshCanvas();
        ds.selection.element = null;

        this.$cursor = $("body").addEl($.div("test-cursor"));
        this.playNextEvent(0);
    }

    stopPlay() {
        console.log("stop playing");
        this.isPlaying = false;
        this.$cursor && this.$cursor.remove();
        app.currentCanvas.model = JSON.parse(this.startModel);
        app.currentCanvas.refreshCanvas();
        ds.selection.element = null;
    }

    playNextEvent(eventIndex) {
        let action = this.eventLog[eventIndex];
        setTimeout(() => {
            if (action.type == "snapshot") {
                console.log("compare snapshot", action.fileName);
            } else {
                if (action.event.type == "mousemove") {
                    this.$cursor.left(action.event.clientX).top(action.event.clientY);
                }
                if (action.event.type == "mousedown") {
                    this.$cursor.addClass("mousedown");
                }
                if (action.event.type == "mouseup") {
                    this.$cursor.removeClass("mousedown");
                }

                if (action.event.type == "click") {
                    console.log("click", action.target);
                }

                if ($(action.target).length) {
                    let event;
                    switch (action.event.type) {
                        case "mousedown":
                        case "mouseup":
                        case "click":
                        case "mousemove":
                            event = new MouseEvent(action.event.type, {
                                bubbles: action.event.bubbles,
                                clientX: action.event.clientX,
                                clientY: action.event.clientY,
                                offsetX: action.event.offsetX,
                                offsetY: action.event.offsetY,
                                button: action.event.button
                            });
                            break;
                        case "keydown":
                        case "keyup":
                        case "keypress":
                            event = new KeyboardEvent(action.event.type, {
                                bubbles: action.event.bubbles,
                                which: action.event.which,
                                keyCode: action.event.keyCode,
                                key: action.event.key
                            });
                            break;
                    }

                    $(action.target)[0].dispatchEvent(event);
                } else {
                    console.log("Error playing action", action.event.type, action.target);
                    console.log($(action.target));
                }

                if (eventIndex < this.eventLog.length - 1) {
                    eventIndex++;
                    if (this.isPlaying) {
                        this.playNextEvent(eventIndex);
                    }
                } else {
                    console.log("playback complete");
                    this.$cursor && this.$cursor.remove();
                    this.isPlaying = false;
                    this.view.render();
                }
            }
        }, action.wait);
    }

    async saveTest() {
        let testName = await ShowDialogAsync(InputDialog, {
            title: "Save Test",
            label: "Test Name",
        });

        if (!testName) return;

        testName = testName.replace(/ /g, "");

        let code = `describe("${testName}", () => {
    const userEmail = Cypress.generateEmail("${testName}");

    before(() => {
        cy.setup();
        cy.deleteUser(userEmail);
        cy.provisionUser({ email: userEmail, emailVerified: true, hasTakenTour: true, plan: "pro" });
    });

    it("runs the test: ${testName}", () => {
        cy.visitLoggedIn(userEmail, "/");
        cy.newPresentation({ name: "${testName}", headline: "${testName}" });

        cy.viewport(1280, 720);

        cy.on("uncaught:exception", (err, runnable) => {
            return false;
        });
        cy.wait(200);

        let startModel = '${this.startModel}';
        let actionLog = '${JSON.stringify(this.eventLog)}';

        cy.window().its("TestRunner").invoke("setup", startModel).then(() => {
            cy.log("complete");
        });

        actionLog = JSON.parse(actionLog);

        for (let action of actionLog) {
            cy.wait(action.wait / 10);
            cy.window().its("TestRunner").invoke("playNextAction", action).then(() => {
                cy.log("complete");
            });
        }

        // take screenshot
        cy.wait(500);
        cy.canvasContainerShouldMatchImageSnapshot();
    });
});
`;

        let blob = new Blob([code], { type: "text/plain;charset=utf-8" });
        saveAs(blob, testName + ".spec.js");
    }
}

export class TestRunner {
    async setup(startModel) {
        app.currentCanvas.model = JSON.parse(startModel);
        app.currentCanvas.updateCanvasModel();
        ds.selection.element = null;
    }

    // async wait(ms) {
    //     return new Promise(resolve => setTimeout(resolve, ms));
    // }

    async playNextAction(action) {
        console.log("play", action.event.type, action.target);

        let target = $(action.target);
        if (!target.length) {
            // if cypress' wait didn't work, retry with a full wait
            await delay(action.wait);
            target = $(action.target);
        }

        if (target.length) {
            let event;
            switch (action.event.type) {
                case "mousedown":
                case "mouseup":
                case "click":
                case "mousemove":
                    event = new MouseEvent(action.event.type, {
                        bubbles: action.event.bubbles,
                        clientX: action.event.clientX,
                        clientY: action.event.clientY,
                        offsetX: action.event.offsetX,
                        offsetY: action.event.offsetY,
                        button: action.event.button
                    });
                    break;
                case "keydown":
                case "keyup":
                case "keypress":
                    event = new KeyboardEvent(action.event.type, {
                        bubbles: action.event.bubbles,
                        which: action.event.which,
                        keyCode: action.event.keyCode,
                        key: action.event.key
                    });
                    break;
            }

            target[0].dispatchEvent(event);
        } else {
            console.log("Error playing action", action.event.type, action.target);
            console.log(target);
        }
    }
}

window.TestRunner = new TestRunner();

